import React from "react";

export interface ClockIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const Clock: React.FC<ClockIconProps> = ({ width = 14, height = 14, color = "#9A9AB0" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_15148_19158)">
        <path
          d="M8.45366 9.70078C8.32503 9.73291 8.1893 9.72027 8.06881 9.66494C6.44843 8.86968 5.13714 7.56003 4.33985 5.94064C4.2808 5.81952 4.2655 5.68169 4.29656 5.55057C4.32761 5.41944 4.4031 5.30311 4.51019 5.22133L4.78322 5.01657C4.92812 4.90789 5.04574 4.76696 5.12674 4.60495C5.20775 4.44294 5.24992 4.26429 5.24992 4.08316V2.33302C5.24992 2.02358 5.12699 1.72681 4.90818 1.508C4.68937 1.28919 4.3926 1.16626 4.08316 1.16626H2.33302C2.02358 1.16626 1.72681 1.28919 1.508 1.508C1.28919 1.72681 1.16626 2.02358 1.16626 2.33302C1.16626 5.11802 2.2726 7.78895 4.24188 9.75824C6.21117 11.7275 8.8821 12.8339 11.6671 12.8339C11.9765 12.8339 12.2733 12.7109 12.4921 12.4921C12.7109 12.2733 12.8339 11.9765 12.8339 11.6671V9.91696C12.8339 9.60752 12.7109 9.31075 12.4921 9.09194C12.2733 8.87313 11.9765 8.7502 11.6671 8.7502H9.91696C9.73583 8.7502 9.55718 8.79237 9.39517 8.87338C9.23316 8.95438 9.09223 9.072 8.98355 9.2169L8.77645 9.48818C8.69614 9.59367 8.58229 9.66865 8.45366 9.70078Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15148_19158">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Clock;
